<template>
  <main-drawer
    :title="`${$tc('general.registration_fee')}${title}`"
    :size="700"
    @close="$emit('close')"
  >
    <el-table :data="participants" style="width: 100%">
      <el-table-column :label="$tc('form.name')">
        <template slot-scope="scope">
          <div class="name">
            {{ scope.row.member ? `${scope.row.member.firstName} ${scope.row.member.lastName}` : '-' }}
          </div>
          <div v-if="showClubName" class="club-name">{{ scope.row.club ? scope.row.club.shortName : '/' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$tc('form.price')" align="right" width="140">
        <template>
          {{ unitPrice }} - {{ unitDiscount }} = {{ unitPrice - unitDiscount }} RSD
        </template>
      </el-table-column>
    </el-table>

    <div class="text">Cena bez popusta: <b>{{ priceWithoutDiscount }} RSD</b></div>
    <div class="text">Cena sa popustom: <b>{{ priceWithDiscount }} RSD</b></div>
    <div v-if="singleClub && costReduction" class="text">
      Popust udruženja: <b>{{ costReduction }}%</b> ({{ priceWithDiscount - total }} RSD)
    </div>
    <div class="text">Ukupno: <b>{{ total }} RSD</b></div>

    <template v-slot:footer>
      <div class="flex-buttons">
        <el-button @click="$emit('close')">{{ $tc('general.close') }}</el-button>
        <el-button type="primary" icon="el-icon-printer" @click="printit">
          {{ $tc('general.print') }}
        </el-button>
      </div>
    </template>

    <print-seminar-registration-fee-by-club
      ref="printTable"
      v-show="false"
      :seminar="seminar"
      :participants="participants"
    />
  </main-drawer>
</template>

<script>
import openPrint from '@/common/print'
import PrintSeminarRegistrationFeeByClub from './PrintSeminarRegistrationFeeByClub.vue'

export default {
  components: { PrintSeminarRegistrationFeeByClub },

  props: {
    seminar: { type: Object, required: true },
    participants: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    showClubName: { type: Boolean, default: true }
  },

  computed: {
    unitPrice () {
      return this.seminar?.single_fee_1 ?? 0
    },
    unitDiscount () {
      return this.seminar?.single_fee_1_break ?? 0
    },
    unitNet () {
      return this.unitPrice - this.unitDiscount
    },
    singleClub () {
      if (!this.participants.length) return null
      const clubIds = [...new Set(this.participants.map(p => p.club?.id).filter(Boolean))]
      return clubIds.length === 1 ? this.participants[0].club : null
    },
    costReduction () {
      if (!this.singleClub) return 0
      const d = (this.seminar?.clubDeductions || []).find(x => parseInt(x.clubId) === parseInt(this.singleClub.id))
      return d ? d.deduction : 0
    },
    priceWithoutDiscount () {
      return this.participants.length * this.unitPrice
    },
    priceWithDiscount () {
      return this.participants.length * this.unitNet
    },
    total () {
      const deductions = this.seminar?.clubDeductions || []
      return this.participants.reduce((sum, p) => {
        const ded = deductions.find(d => parseInt(d.clubId) === parseInt(p.club?.id))?.deduction || 0
        const price = ded ? Math.round((this.unitNet * (100 - ded)) / 100) : this.unitNet
        return sum + price
      }, 0)
    }
  },

  methods: {
    printit () {
      this.$nextTick(() => {
        openPrint(
          this.$tc('general.registration_fee') + (this.title ? ` - ${this.title}` : ''),
          this.$refs.printTable ? this.$refs.printTable.$el : null
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text { margin-top: 10px; text-align: right; }
.name { line-height: 1.6; }
.club-name { font-size: 11px; line-height: 1; }
</style>
